import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner, you can change the role of any member of your organization to add or remove permissions on the organization for that member.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-members-tab'].text}</>
        <>{shared['organization-members-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the list of organization members, find the member whose role you want to change.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the member row, to select the new role of the organization member, click `}<strong parentName="p">{`member`}</strong>{`, `}<strong parentName="p">{`admin`}</strong>{`, or `}<strong parentName="p">{`owner`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-organization-members/change-member-role.png" alt="Screenshot showing the change member role option" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      